import React from "react";
import "./index.css";

function Footer() {
    return (
        <footer className="footer">
            <p className="footer__text">&copy; Lorem ipsum dolor sit amet consectetur adipisicing elitm laboriosam ducimus quia necessitatibus aliquid maiores</p>
        </footer>
    );
}

export default Footer;